export default __webpack_public_path__ + "static/media/tv.ad757e28.svg";